import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { ChevronLeft, ChevronRight } from 'lucide-react';
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { specraFocusRing } from '../ensigns/focus-ring';
import { SpecraNavigationGroupView } from '../lieutenants/navigation-group';
import { SpecraProgramIdentity } from '../lieutenants/program-identity';
/** Program-aware navigation rail from the Delivery redesign. */ export const SpecraProgramSidebar = /*#__PURE__*/ React.forwardRef(({ backAction, brand, className, collapsed = false, collapseLabel = 'Collapse navigation (⌘\\)', collapseToggleTestId, expandLabel = 'Expand navigation (⌘\\)', footer, getGroupProps, getGroupTestId, groups, navigationLabel = 'Program', navigationTestId, onCollapseToggle, programId, programName, renderLink, toggleControl, ...props }, ref)=>{
    const resolvedToggle = toggleControl ?? (onCollapseToggle ? /*#__PURE__*/ _jsx("button", {
        "aria-expanded": !collapsed,
        "aria-label": collapsed ? expandLabel : collapseLabel,
        className: cn('flex size-5 cursor-pointer items-center justify-center rounded-full border border-border bg-background text-muted-foreground shadow-sm transition-colors hover:border-border-strong hover:text-foreground', specraFocusRing),
        "data-testid": collapseToggleTestId,
        onClick: onCollapseToggle,
        title: collapsed ? expandLabel : collapseLabel,
        type: "button",
        children: collapsed ? /*#__PURE__*/ _jsx(ChevronRight, {
            "aria-hidden": "true",
            className: "size-3"
        }) : /*#__PURE__*/ _jsx(ChevronLeft, {
            "aria-hidden": "true",
            className: "size-3"
        })
    }) : undefined);
    return /*#__PURE__*/ _jsxs("div", {
        className: cn('relative flex max-h-[var(--component-sidebar-mobile-max-height)] w-full shrink-0 flex-col bg-background transition-[width] duration-[var(--dur-base)] md:h-full md:max-h-none', collapsed ? 'md:w-[var(--component-sidebar-collapsed-width)]' : 'md:w-[var(--component-sidebar-width)]', className),
        ref: ref,
        ...props,
        children: [
            brand ? /*#__PURE__*/ _jsxs("div", {
                className: cn('flex min-h-12 items-center', collapsed ? 'justify-center px-2' : 'px-4'),
                children: [
                    brand,
                    resolvedToggle ? /*#__PURE__*/ _jsx("div", {
                        className: "absolute right-0 top-6 z-10 translate-x-1/2",
                        children: resolvedToggle
                    }) : null
                ]
            }) : /*#__PURE__*/ _jsx(SpecraProgramIdentity, {
                backAction: backAction,
                collapsed: collapsed,
                programId: programId,
                programName: programName ?? '',
                toggleControl: resolvedToggle
            }),
            /*#__PURE__*/ _jsx("nav", {
                "aria-label": navigationLabel,
                className: "min-h-0 flex-1 overflow-y-auto px-2.5 py-2",
                "data-testid": navigationTestId,
                children: groups.map((group, groupIndex)=>{
                    const groupProps = getGroupProps?.(group);
                    return /*#__PURE__*/ _createElement(SpecraNavigationGroupView, {
                        ...groupProps,
                        className: cn(groupIndex > 0 && (collapsed ? 'mt-3 border-t border-border pt-3' : 'mt-4'), groupProps?.className),
                        collapsed: collapsed,
                        "data-testid": getGroupTestId?.(group),
                        group: group,
                        key: group.id,
                        renderLink: renderLink
                    });
                })
            }),
            footer ? /*#__PURE__*/ _jsx("div", {
                className: "shrink-0 border-t border-border p-3",
                children: footer
            }) : null
        ]
    });
});
SpecraProgramSidebar.displayName = 'SpecraProgramSidebar';
